import { svgsIndex } from "facesjs";
import { choice } from "../../../../common/random.ts";

const genRandomJersey = () => {
	const jerseys = svgsIndex.jersey.filter((id) => id.startsWith("jersey"));
	return choice(jerseys);
};

export default genRandomJersey;
